import { ReviewItemProps } from '@zola/zola-ui/src/components/PreAuthV3/ReviewItem';

export const reviewItems: ReviewItemProps[] = [
  {
    name: 'Ola',
    reviewText:
      'Zola is truly a fantastic experience, from the planning to the save the dates, invites, everything! I love the checklist and the beautiful designs ...',
    title: 'Absolutely obsessed with Zola',
  },
  {
    name: 'Russel',
    reviewText:
      'Creating our invitations using Zola was easy, inexpensive and they address the envelopes free of charge! Zola has also been a big help with planning...',
    title: 'Can’t thank Zola enough!',
  },
  {
    name: 'Laura',
    reviewText:
      'It was so easy to choose a design and then immediately have coordinating options for all of our wedding paper needs! We just plugged in our info an...',
    title: 'Beautiful stationery',
  },
];
